module.exports = __webpack_public_path__ + "static/android-icon-192x192-77ac39a9e3d2cc33351bd8f8690873a4.png";